import { Component, OnDestroy, OnInit, ViewChild, ElementRef } from '@angular/core';
import { environment } from '@environments/environment';
import { AbstractModalContentComponent } from '@ibe.components/common/modal/abstract-modal-content.component';
import { ModalService } from '@ibe/services/ui';
import * as Moment from 'moment';
import { extendMoment } from 'moment-range';
import { IMyDateModel, IMyDpOptions, IMySelector } from 'mydatepicker';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import * as fromStore from '../../../store';
import { takeWhile } from 'rxjs/operators';
import { INDRADateService } from '@ibe.services/date.indra.service';
import { INDRAIbeAdminService } from '@ibe.services/ibeadmin.indra.service';

const moment = extendMoment(Moment);
const sinceDays = 360;

@Component({
	selector: 'app-datepicker-modal',
	templateUrl: './datepicker-modal.indra.component.html',
	styleUrls: ['./datepicker-modal.component.scss']
})
export class INDRADatepickerModalComponent extends AbstractModalContentComponent implements OnInit, OnDestroy {


	@ViewChild('monthScroll') monthScroll: ElementRef<any>;
	scrollLeft = 0;

	isAlive = true;

	bookAwardFlights$: Observable<boolean> = this.store.select(fromStore.getFlightsFilterBookAwardFlights);
	bookAwardFlights: boolean;

	// Initialize selector state to false
	datepickerSelector: IMySelector = {
		open: false
	};
	// https://www.npmjs.com/package/angular4-datepicker
	datepickerOptions: IMyDpOptions = {
		showClearDateBtn: false,
		disableUntil: { year: moment().year(), month: moment().month() + 1, day: parseFloat(moment().format('D')) },
		disableSince: { year: parseFloat(moment().add(sinceDays, 'days').format('YYYY')), month: parseFloat(moment().add(sinceDays, 'days').format('M')), day: parseFloat(moment().add(sinceDays, 'days').format('D')) },
		markCurrentDay: true,
		yearSelector: false,
		monthSelector: false,
		showSelectorArrow: false,
		openSelectorOnInputClick: true,
		allowSelectionOnlyInCurrentMonth: false,
		inline: true,
		satHighlight: false,
		sunHighlight: false,
		showTodayBtn: false,
		ariaLabelInputField: 'Flight\'s new date',
		dayLabels: this.INDRA_getDays(),
		allowDeselectDate: false,
		ariaLabelDay: 'Select day '
	};

	myDateModel: any;
	range = moment.range(moment().endOf('month'), moment().add(sinceDays, 'days').endOf('month'));

	defMonth = `${moment().format('MM')}-${moment().format('YYYY')}`;
	defMonthIndex;

	optionsMonth = Array.from(this.range.by('month')).map(cur => ({ value: cur.format('MM-YYYY'), label: `${this.INDRA_getTranslationKey('dates.text.' + (cur.format('MMMM')).toLowerCase()).substring(0,3)} ${cur.format('YY')}` }));

	openSelectorTimeout;
	defMonthTimeout;

	constructor(
		protected modalService: ModalService,
		private store: Store<fromStore.State>,
		private dateSerivce: INDRADateService,
		private ibeAdminService: INDRAIbeAdminService
	) {
		super(modalService);
		moment.locale(environment.locale);

		this.bookAwardFlights$
		.pipe(takeWhile(() => this.isAlive))
		.subscribe(value => {
			this.bookAwardFlights = value;
		});

		this.datepickerOptions.dateFormat = this.dateSerivce.INDRA_getDateFormat().toLowerCase();
	}

	ngOnInit() {
		if (this.data && this.data[0] && this.data[0].params && this.data[0].params.datepickerOptions && this.data[0].params.datepickerOptions.disableSince.year !== 'Invalid date') {

			this.datepickerOptions = Object.assign(this.datepickerOptions, this.data[0].params.datepickerOptions);
			if (this.datepickerOptions.disableUntil) {

				if (this.datepickerOptions.disableUntil.day == parseFloat(moment().format('D')) - 1 && this.bookAwardFlights) {
					// disable until current day if bookAwardFlight and datepicker is first row
					this.datepickerOptions.disableUntil.day = parseFloat(moment().format('D'));
				}

				const departure = moment(`${this.datepickerOptions.disableUntil.day}-${this.datepickerOptions.disableUntil.month}-${this.datepickerOptions.disableUntil.year}`, 'D-M-YYYY');
				this.defMonth = `${departure.format('MM')}-${departure.format('YYYY')}`;
			}
		}

		if (this.data && this.data[0] && this.data[0].params && this.data[0].params.value) {
			const value = moment(this.data[0].params.value, 'DD/MM/YYYY');
			this.myDateModel = { date: { year: parseFloat(value.format('YYYY')), month: parseFloat(value.format('M')), day: parseFloat(value.format('D')) } };
			this.defMonth = `${value.format('MM')}-${value.format('YYYY')}`;
		}

		clearTimeout(this.openSelectorTimeout);
		this.openSelectorTimeout = setTimeout(() => this.openSelector(), 100);
	}

	ngOnDestroy() {
		this.isAlive = false;
	}

	openSelector() {
		this.TAP_handleMoveMonth(this.TAP_findIndexMonth(), 'auto');

		this.datepickerSelector = {
			open: true
		};
	}

	closeSelector() {
		this.datepickerSelector = {
			open: false
		};
	}

	onDateChanged(event: IMyDateModel) {
		if (this.data && this.data[0] && this.data[0].handleClose) {
			this.data[0].handleClose(event);
		}
		this.closeModal();
	}

	calendarToggle(event) {
		return;
	}

	calendarViewChanged(event) {
		if (`${moment(event.month, 'M').format('MM')}-${event.year}` != this.defMonth) {
			// this.TAP_changeMonth(`${moment(event.month, 'M').format('MM')}-${event.year}`);
			const index = this.optionsMonth.findIndex(cur => cur.value == `${moment(event.month, 'M').format('MM')}-${event.year}`);
			this.TAP_handleMoveMonth(index);
		}
	}

	TAP_changeMonth(defMonth) {
		this.myDateModel = null;

		if (this.data && this.data[0] && this.data[0].params && this.data[0].params.value) {
			const value = moment(this.data[0].params.value, 'DD/MM/YYYY');

			if (defMonth == `${value.format('MM')}-${value.format('YYYY')}`) {
				this.myDateModel = { date: { year: parseFloat(value.format('YYYY')), month: parseFloat(value.format('M')), day: parseFloat(value.format('D')) } };
			}

		}

		clearTimeout(this.defMonthTimeout);
		this.defMonthTimeout = setTimeout(() => {
			this.defMonth = defMonth;
		}, 1);

	}

	TAP_handleMoveMonth(index = 0, behavior: ScrollBehavior = 'smooth') {
		const el: HTMLBaseElement = this.monthScroll.nativeElement;

		if (index != -1) {
			const defMonth = this.optionsMonth[index].value;
			this.TAP_changeMonth(defMonth);

			this.defMonthIndex = index;
			// const scrollLeft = index * el.offsetWidth;
			// el.scrollTo({ left: scrollLeft, top: 0, behavior });
		}
	}

	TAP_findIndexMonth() {
		return this.optionsMonth.findIndex(cur => cur.value == this.defMonth);
	}

	TAP_handleMoveBack() {
		let index = this.optionsMonth.findIndex(cur => cur.value == this.defMonth);
		if (index > 0) {
			--index;
		} else {
			index = 0;
		}

		this.TAP_handleMoveMonth(index);
	}

	TAP_handleMoveForward() {
		let index = this.optionsMonth.findIndex(cur => cur.value == this.defMonth);

		if (index >= (this.optionsMonth.length - 1)) {
			index = this.optionsMonth.length - 1;
		} else {
			++index;
		}
		this.TAP_handleMoveMonth(index);
	}

	INDRA_getTranslationKey(key: string, isDays?): string {
		if (isDays) {
			return this.ibeAdminService.getTranslationValue(key).substring(0,1).toUpperCase();
		} else {
			return this.ibeAdminService.getTranslationValue(key);
		}
	}

	INDRA_getDays() {
		const isDays = true;
		const days = {
			su: this.INDRA_getTranslationKey('dates.text.sunday', isDays),
			mo: this.INDRA_getTranslationKey('dates.text.monday', isDays),
			tu: this.INDRA_getTranslationKey('dates.text.tuesday', isDays),
			we: this.INDRA_getTranslationKey('dates.text.wednesday', isDays),
			th: this.INDRA_getTranslationKey('dates.text.thursday', isDays),
			fr: this.INDRA_getTranslationKey('dates.text.friday', isDays),
			sa: this.INDRA_getTranslationKey('dates.text.saturday', isDays)
		}
		return days;
	}
}
